export enum WidgetPermissionTypeEnum {
	ByMinimum = 0,
	ByMaximum = 1,
	Custom = 2
}

export namespace WidgetPermissionTypeEnum {
	export function toDescription(val: WidgetPermissionTypeEnum) {
		switch (val) {
			case 0:
				return "By Minimum";
			case 1:
				return "By Maximum";
			case 2:
				return "Custom";
		}
		return null;
	}
	export function toDisplay(val: WidgetPermissionTypeEnum) {
		switch (val) {
			case 0:
				return "ByMinimum";
			case 1:
				return "ByMaximum";
			case 2:
				return "Custom";
		}
		return null;
	}
}
